import { errorCode, errorMessage } from '@/shared/lib'

// Коды бэкенда при заведении голоса — словами и с действием.
const createErrorTexts: Record<string, string> = {
  VOICE_NO_UNIT: 'Нет живого C-юнита — транскрибировать клип некому. Подними юнит и повтори.',
  VOICE_NO_LLM: 'LLM недоступна — нормализовать текст некому. Подними L-юнит и повтори.',
  VOICE_BAD_INPUT: 'Аудио не годится: нужен клип 1–60 секунд, лучше 15–25 секунд ровной речи.',
  VOICES_OWNER_REQUIRED:
    'Нужен владелец: без owner_account_id голос платформенный, а такие заводит только оператор.',
  VOICES_FORBIDDEN: 'Платформенный голос принадлежит оператору — приложению он только на чтение.',
}

export function voiceCreateErrorMessage(error: unknown): string {
  return createErrorTexts[errorCode(error)] ?? errorMessage(error)
}
